import React from 'react'

export default function Answer() {
    return (
        <div className='px-4 md:px-12'>
            <h1 className='md:text-5xl text-2xl font-bold text-center my-6 md:my-12 text-sky-900'>Why Choose Us?</h1>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
                <WhyUs
                    heading="Top Industry Experts"
                    content="We are a community of top industry experts that provides academic counseling and a complete career path.
                Top industry professionals who give each member personalized attention while considering both their skillset and interests"
                />
                <WhyUs
                    heading="Live Mentorship"
                    content="We provide live mentorship to the students. Assist them and help them in finding the best career path.
                We build relationships with students which keep them growing."
                />
                <WhyUs
                    heading="One-to-One Counseling"
                    content="We provide one-to-one live counseling to the students, resolve their doubts related to career planning and provide 
                proper assistance"
                />
            </div>
        </div>

    )
}


function WhyUs(props) {
    return (
        <div className="card bg-sky-200 text-slate-800 shadow-xl">
            <div className="card-body">
                <h2 className='card-title text-center'>{props.heading}</h2>
                <hr className='h-1 bg-slate-100'></hr>
                <p className='text-left mt-2'>{props.content}</p>
            </div>
        </div>
    )
}